/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';
import _ from 'lodash';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { userHasRole } from '@/util/RoleUtils';

import GetInternalUserEPCProfile from '../services/GetInternalUserEPCProfile';
import IntEPCProfilePage from '../pages/IntEPCProfilePage';
import ErrorView from '../../common/views/ErrorView/ErrorView';

export default async function ShowIntEPCProfilePage() {
  NProgress.start();

  try {
    const profile = await GetInternalUserEPCProfile();

    if (userHasRole('EPC')) {
      NavUtils.navigate('epc-profile');
    } else {
      showErrorView({ message: 'Unauthorized' });
      return;
    }

    Scaffold.getRegion('content').show(new IntEPCProfilePage({ model: new Backbone.Model({ profile }) }));
  } catch (err) {
    showErrorView(err);
  } finally {
    NProgress.done();
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'An Error Occurred'
      })
    })
  );
}
